import React from 'react';
import { IconSvgProps } from '@models/common';

const Close: React.FC<IconSvgProps> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      stroke='currentColor'
      viewBox='0 0 24 24'>
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        d='m18 6.5-12 12M6 6.5l12 12'
      />
    </svg>
  );
};

export default Close;
